import OT from '@opentok/client';

export default () => OT.hasMediaProcessorSupport();
